import { useEffect, useState } from 'react';
import { BusinessesService } from 'service/businesses.service';

type PlatformInsightsType = {
  metrics: Record<string, number>;
  fitRecommendations: {
    clientId: string;
    clientName: string;
    score: number;
    reasons: string[];
  }[];
};

export const usePlatformInsights = (id: string) => {
  const [data, setData] = useState<PlatformInsightsType | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getDetails = async (id: string) => {
      try {
        setLoading(true);
        const res = await BusinessesService.getPlatformInsights(id);
        setData(res);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    getDetails(id);
  }, [id]);

  return { data, loading };
};
